import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';
import useHasMappedWhyBuyFeatures from './useHasMappedWhyBuyFeatures';

export default function useIsInWhyBuyImageryExperiment() {
  const hasMappedFeatures = useHasMappedWhyBuyFeatures();
  const isInTreatment = useIsInExperiment(
    'car-merch-ui-vdp-why-buy-imagery',
    'treatment'
  );

  return isInTreatment && hasMappedFeatures;
}
